import {useMutation} from '@tanstack/react-query';
import {apiClient, queryClient} from '@common/http/query-client';
import {onFormQueryError} from '@common/errors/on-form-query-error';
import {UseFormReturn} from 'react-hook-form';
import { Prompt } from '@app_modules/chats/prompt';
import { BackendResponse } from '@common/http/backend-response/backend-response';
import { UwChatDemo } from '../chat-uw';


interface Response extends BackendResponse {
  prompt: Prompt;
}

export interface DemoUwPayload extends UwChatDemo {
 report_id: string;
}

export function useDemoChatUw(form: UseFormReturn<DemoUwPayload>) {
  return useMutation({
    mutationFn: (payload: DemoUwPayload) => createUwChatAction(payload),
    onSuccess: response => {
      
      // toast(trans(message('Chat updated')));
      // queryClient.invalidateQueries({
      //   queryKey: [Endpoint(response. chat.id)],
      // });
      // queryClient.invalidateQueries({
      //   queryKey: DatatableDataQueryKey('chats'),
      // });
    },
    onError: err => onFormQueryError(err, form),
  });
}

async function createUwChatAction(payload: DemoUwPayload) {
  return apiClient.post<Response>('demo-chat-uw', FilePayloadToFormData(payload), {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }).then(r => r.data);
}


export function FilePayloadToFormData(
payload: Partial<DemoUwPayload>,
) {
  const formData = new FormData();

  if (payload.prompt != undefined) {
    formData.append("prompt", payload.prompt);
  }

  if (payload.report_id != undefined) {
    formData.append("report_id", payload.report_id);
  }

  if (payload.sources != undefined) {
    payload.sources.forEach((source) => {
      formData.append("sources[]", source);
    });
  }

  // if (payload.files) {
  //   payload.files.forEach((file) => {
  //     formData.append("files[]", file);
  //   });
  // }

  return formData;
}